import { render, staticRenderFns } from "./ToTop.vue?vue&type=template&id=400545f6&scoped=true&"
import script from "./ToTop.vue?vue&type=script&lang=js&"
export * from "./ToTop.vue?vue&type=script&lang=js&"
import style0 from "./ToTop.vue?vue&type=style&index=0&id=400545f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400545f6",
  null
  
)

export default component.exports